// @flow
import { getAuthToken, getBidderEmail, getUserData } from './user';
import { createSelector } from 'reselect';
import { DISMISS_MODAL } from './modal';
import { getCompleteAccountAnalytics } from './analytics';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { postCompleteAccount } from '../api/bidder';

/* Action Types */
export const COMPLETE_ACCOUNT_FAIL = 'la/ui/completeAccount/FAIL';
export const COMPLETE_ACCOUNT_REQUEST = 'la/ui/completeAccount/REQUEST';
export const COMPLETE_ACCOUNT_SUCCESS = 'la/ui/completeAccount/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DISMISS_MODAL:
            return {
                ...state,
                error: false,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        case COMPLETE_ACCOUNT_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case COMPLETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.completeAccount;

export const getUiCompleteAccount = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitCompleteAccount = (userDetails: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const userData = getUserData(state);
        userDetails.email = getBidderEmail(state);
        userDetails.username = userData.username;

        dispatch({
            type: COMPLETE_ACCOUNT_REQUEST,
        });
        const response = await postCompleteAccount({
            authToken,
            bidderDetails: userDetails,
            deployment,
        });
        dispatch({
            meta: { ...getCompleteAccountAnalytics(), actionTime: Date.now() },
            payload: response,
            type: COMPLETE_ACCOUNT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: COMPLETE_ACCOUNT_FAIL,
        });
    }
};
